import axios from "axios";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import EmptyData from "../../Components/utils/empty";
import Loader from "../../Components/utils/loader";
import { displayAlert } from "../../helpers/alert";
import { baseURL } from "../../Config/config";
import MailingsCards from "./MailingsCards";

const Mailings = () => {
  const [mailings, setMailings] = React.useState(null);
  const [originalMailings, setOriginalMailings] = React.useState(null);
  const [data, setData] = React.useState();

  async function getAllMailings() {
    axios
      .get(`${baseURL}/mailings`)
      .then((response) => {
        if (response.data.error) return;
        setMailings(response.data.data);
        setOriginalMailings(response.data.data);
      })
      .catch((err) => {
        setData(<EmptyData />);
        displayAlert("error", "Erreur est survenue !", "Veuiller réessayer !");
      });
  }

  async function filter(text = "") {
    const items = originalMailings;
    const results = items.filter(
      (item) =>
        item.name && item.name.toLowerCase().includes(text.toLowerCase())
    );
    setMailings(results);
  }

  useEffect(() => {
    setData(<Loader />);
    getAllMailings();
  }, []);

  useEffect(() => {
    if (mailings == null) return;
    if (mailings.length > 0) {
      setData(
        <MailingsCards mailings={mailings} refreshData={getAllMailings} />
      );
    } else {
      setData(<EmptyData />);
    }
  }, [mailings]);

  return (
    <>
      <div className="breadcrumbs">
        <div className="breadcrumbs-inner">
          <div className="row m-0">
            <div className="col-md-8 col-12">
              <div className="page-header float-left">
                <div className="page-title">
                  <h1>
                    <span className="me-5">Liste des Mailings</span>{" "}
                    <small className=" ml-5">
                      <Link className="text-secondary" to={"/mailings/create"}>
                        <i className="fa fa-plus"></i> Ajouter
                      </Link>
                    </small>
                  </h1>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="page-header float-right">
                <div className="page-title">
                  <ol className="breadcrumb text-right">
                    <li>
                      <input
                        className="form-control"
                        placeholder="Saisir le nom"
                        onChange={(e) => {
                          filter(e.target.value);
                        }}
                      />
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="animated">
          <div className="">{data}</div>
        </div>
      </div>
    </>
  );
};

export default Mailings;
